import { Component, h, Prop, State, Host, Listen } from '@stencil/core';

@Component({
	tag: 'kdx-speedbump',
	styleUrl: 'kdx-speedbump.scss',
	shadow: false,
})
export class AppSpeedbump {

	@Prop() returnText: string;
	@Prop() continueText: string;
	@Prop() defaultHeadline: string = "Third Party Site Disclaimer";
	@Prop() defaultMessage: string;

	@State() info = {
		open: false,
		message: '',
		url: ''
	};

	@Listen('click', { target: 'document' })
	openSpeedbump(e: any) {
		let targetElement = (e.target as HTMLElement);

		if (targetElement?.closest('[data-speedbump], .speedbump-link')) {
			e.preventDefault();      
			const url = targetElement.closest('[data-speedbump], .speedbump-link').getAttribute('href');
		
			this.info = {
				open: true,
				message: this.defaultMessage,
				url: url
			};      
			return;
		}
	}

	closeSpeedbump(e, allowDefault = false) {
		if (!allowDefault) {
			e.preventDefault();
		}

		this.info = {
			open: false,
			message: '',
			url: ''
		};
	}

	render() {
		if (!this.info.open) {
			return (<Host />);
		}

		return (
		<div class="speedbump" role="alert" aria-label={this.info.message}>
			<div class="speedbump__overlay" onClick={(e) => {this.closeSpeedbump(e)}}></div>
			<div class="speedbump__inner">
				<a href="#" class="js-close-speedbump" aria-label="click to close speedbump and stay on site" onClick={(e) => {this.closeSpeedbump(e)}}>
					<kdx-icon icon="close-thin"></kdx-icon>
				</a>
				<div class="speedbump__content">
					<slot />
				</div>
				<h2 class="speedbump__headline h3">{this.defaultHeadline}</h2>
				<p class="speedbump__message">
					{ this.info.message }
				</p>
				<div class="speedbump__actions">
					<a
						href={this.info.url}
						target="_blank"
						rel="noopener noreferrer"
						aria-label={this.continueText}
						class="close-speedbump btn btn-primary"
						onClick={(e) => {this.closeSpeedbump(e, true)}}>
						{this.continueText}
					</a>
					<a
						href="#"
						aria-label={this.returnText}
						onClick={(e) => {this.closeSpeedbump(e)}}
						class="arrow-link">
						{this.returnText}
						<kdx-icon icon="chevron-right"></kdx-icon>
					</a>
				</div>
			</div>
		</div>
		);
	}

}
